import { createContext, useContext } from "react";

// initial global state with objects
export const IsGlobalContext = createContext({ version: "v2.3.6" });

export const getGlobalStateContext = () => {
  return useContext(IsGlobalContext);
};
